import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    padding: theme.spacings.md,
  },
  text: {
    fontSize: theme.fontSizes.xl,
  },
});
